import React from 'react'
import errorImg from "../../asserts/404error.svg"
import Backdrop from "../../asserts/CRMbg.png"
import "../../App.css"

export const PageNotFound = () => {
  return (
    <div
    className={`h-screen w-screen px-[2.5vw]`}
    style={{
            backgroundImage: `url(${Backdrop})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
    >
    <img src={errorImg} alt='403 error' className='w-[20vw] mx-auto pt-[5vw]'/>
    <p className='flex justify-center text-[1.5vw] mt-[2vw]'>⚠️ Oops! Page Not Found</p>
    <p className='flex justify-center mt-[1vw]'>It looks like you are lost or visiting the page that doesn't exist.</p>
    <p className='flex justify-center mt-[1vw]'>Please try to login again or reach out to your administrator/support team.</p>
    </div>
  )
}